import { AddEquation, AdditiveBlending, DstColorFactor, Mesh, MultiplyBlending, Object3D, PlaneBufferGeometry, RawShaderMaterial, SphereBufferGeometry, SrcColorFactor } from "three";

export default class Atmosphere extends Object3D {
  constructor(){
    super()
    const geo = new SphereBufferGeometry(670, 100, 50, 50)
    const mat = new RawShaderMaterial({
      vertexShader: /* glsl */`#version 300 es
      in vec3 position;
      in vec3 normal;
      in vec2 uv;

      uniform mat3 normalMatrix;
      uniform mat4 modelMatrix;
      uniform mat4 viewMatrix;
      uniform mat4 projectionMatrix;

      out vec2 vUv;
      out vec3 vNormal;

      void main() {
        vUv = uv;
        vNormal = normalMatrix * normal;
        gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(position, 1.0);
      }
      `,
      fragmentShader: /* glsl */`#version 300 es
      precision highp float;
      in vec2 vUv;
      in vec3 vNormal;
      uniform vec2 resolution;
      out vec4 outColor;

      highp float basicDithering (in highp vec2 st, highp float intensity) {
        return mix(
            -intensity/ 255.,
            intensity/255.,
            fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123)
        );
      }


      void main() {
        vec3 unit = vec3(0.0, 0.0, 1.0);
        float f = 1.0 - dot(unit, vNormal);
        outColor = vec4(vec3(f), f);
      }
      `,
      uniforms: {
        resolution: { value: [window.innerWidth, window.innerHeight] },
      },
      transparent: true,
      depthTest: true,
      depthWrite: false,
    })

    const mesh = new Mesh(geo, mat)
    this.add(mesh)
  }
}